import { createSlice } from '@reduxjs/toolkit'

export const productSlice = createSlice({
  name: 'product',
  initialState: {
    product: null,
    zoomOpen: false,
    zoomImageId: null,
    colorModalOpen: false,
    oosOpen: false,
    oosEmailValid: true,
    oosSubmited: false,
  },
  reducers: {
    setProduct: (state, action) => {
      state.product = action.payload
    },
    setZoomOpen: (state, action) => {
      state.zoomOpen = action.payload
    },
    setZoomImageId: (state, action) => {
      state.zoomImageId = action.payload
    },
    setColorModalOpen: (state, action) => {
      state.colorModalOpen = action.payload
    },
    setOosOpen: (state, action) => {
      state.oosOpen = action.payload
    },
    setEmailValidity: (state, action) => {
      state.oosEmailValid = action.payload
    },
    setOosSubmited: (state, action) => {
      state.oosSubmited = action.payload
    },
  },
})

export const { setProduct, setZoomOpen, setZoomImageId, setOosOpen, setEmailValidity, setOosSubmited, setColorModalOpen } = productSlice.actions

export default productSlice.reducer
